import { NavigationItem, NavigationConfig } from "../types";
import { createBuilderContext } from "./context";
import { buildDashboardSection } from "./sections/dashboard";
import { buildSalesSection } from "./sections/sales";
import { buildMarketingSection } from "./sections/marketing";
import { buildInboxSection } from "./sections/inbox";
import { buildWorkSection } from "./sections/work";
import { buildVaultSection } from "./sections/vault";
import { buildInsightsSection } from "./sections/insights";
import { buildAdminSection } from "./sections/admin";
import { buildMeridianSection } from "./sections/meridian";

/**
 * Compose the full top-level navigation from per-section builders. Each
 * builder returns a NavigationItem (or null when the section should not
 * appear for the current user/feature-flag combination).
 */
export function buildNavigationSections(config: NavigationConfig): NavigationItem[] {
  const ctx = createBuilderContext(config);

  // Order is significant - each section sets its own `order` field, but the
  // resulting array order also matches that order so consumers that ignore
  // `order` still render correctly.
  const sectionBuilders = [
    buildDashboardSection,
    buildSalesSection,
    buildMarketingSection,
    buildInboxSection,
    buildWorkSection,
    buildVaultSection,
    buildInsightsSection,
    buildAdminSection,
    buildMeridianSection,
  ];

  const sections: NavigationItem[] = [];
  for (const build of sectionBuilders) {
    const section = build(ctx);
    if (section) sections.push(section);
  }
  return sections;
}
